module.exports = __webpack_public_path__ + "assets/img/left-arrow.6de8d340.svg";